/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface PatchedWindDragCoefficient
 */
export interface PatchedWindDragCoefficient {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly simulation?: string;
  /**
   * global drag coefficient (0-100)
   */
  value?: number;
  /**
   *
   */
  readonly uid?: string;
  /**
   *
   */
  readonly id?: number;
}

/**
 * Check if a given object implements the PatchedWindDragCoefficient interface.
 */
export function instanceOfPatchedWindDragCoefficient(
  value: object
): value is PatchedWindDragCoefficient {
  return true;
}

export function PatchedWindDragCoefficientFromJSON(json: any): PatchedWindDragCoefficient {
  return PatchedWindDragCoefficientFromJSONTyped(json, false);
}

export function PatchedWindDragCoefficientFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedWindDragCoefficient {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    value: json["value"] == null ? undefined : json["value"],
    uid: json["uid"] == null ? undefined : json["uid"],
    id: json["id"] == null ? undefined : json["id"],
  };
}

export function PatchedWindDragCoefficientToJSON(json: any): PatchedWindDragCoefficient {
  return PatchedWindDragCoefficientToJSONTyped(json, false);
}

export function PatchedWindDragCoefficientToJSONTyped(
  value?: Omit<PatchedWindDragCoefficient, "url" | "simulation" | "uid" | "id"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    value: value["value"],
  };
}
